
import React from 'react';

export const BackgroundEffects = () => (
  <div className="shinchan-container" style={{ transform: 'scale(0.25)', bottom: '300px', right: '10px' }}>
    <div className="face"> 
      <div className="forhead"></div>
      <div className="cheeks"></div>
      <div className="ear"></div>
      <div className="eyebrow left"></div>
      <div className="eyebrow right"></div>
      <div className="eye left"></div>
      <div className="eye right"></div>
      <div className="mouth"></div>
      <div className="shy"></div>
      <div className="shy right"></div>
    </div>
  </div>
);

export const TypingIndicator = () => (
  <div className="flex space-x-2">
    <div className="w-2 h-2 bg-pink-400 rounded-full animate-bounce"></div>
    <div className="w-2 h-2 bg-pink-400 rounded-full animate-bounce" style={{animationDelay: '0.2s'}}></div>
    <div className="w-2 h-2 bg-pink-400 rounded-full animate-bounce" style={{animationDelay: '0.4s'}}></div>
  </div>
); 